export default "__VITE_ASSET__CdE4$qka__"